import { QRCodeSVG } from 'qrcode.react';
import styled, { useTheme } from 'styled-components';

import LogoMarkBadgeSvg from '../../../assets/logos/logo-mark-badge.svg?react';
import { useTipsShareQrUrl } from '../model/use-tips-share-qr-url';

const QrSurface = styled.div.attrs({
  'aria-hidden': true,
  'data-ui': 'tips-share-qr-code',
})<{ $size: number }>`
  width: ${({ theme, $size }) => theme.scale.px($size)};
  height: ${({ theme, $size }) => theme.scale.px($size)};
  position: relative;
  display: grid;
  place-items: center;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface.base};

  & > svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const LogoBadgeShell = styled.div<{ $size: number }>`
  width: ${({ theme, $size }) => theme.scale.px($size)};
  height: ${({ theme, $size }) => theme.scale.px($size)};
  position: absolute;
  top: 50%;
  left: 50%;
  display: grid;
  place-items: center;
  border-radius: ${({ theme }) => theme.scale.px(8)};
  background: ${({ theme }) => theme.colors.surface.base};
  pointer-events: none;
  transform: translate(-50%, -50%);
`;

const LogoBadge = styled(LogoMarkBadgeSvg).attrs({
  'aria-hidden': true,
})<{ $size: number }>`
  width: ${({ theme, $size }) => theme.scale.px($size)};
  height: ${({ theme, $size }) => theme.scale.px($size)};
  display: block;
`;

type TipsShareQrCodeProps = {
  className?: string;
  size: number;
  tipsShareUrl?: string | null;
};

export function TipsShareQrCode({
  className,
  size,
  tipsShareUrl = undefined,
}: TipsShareQrCodeProps) {
  const theme = useTheme();
  const resolvedTipsShareUrl = useTipsShareQrUrl();
  const qrUrl = tipsShareUrl ?? resolvedTipsShareUrl;
  const logoBadgeSize = Math.max(24, Math.round(size * 0.25));
  const logoShellSize = Math.max(30, Math.round(size * 0.31));

  return (
    <QrSurface $size={size} className={className}>
      {qrUrl ? (
        <>
          <QRCodeSVG
            bgColor={theme.colors.surface.base}
            fgColor={theme.colors.text.primary}
            includeMargin
            level="H"
            size={theme.scale.value(size)}
            value={qrUrl}
          />
          <LogoBadgeShell $size={logoShellSize}>
            <LogoBadge $size={logoBadgeSize} />
          </LogoBadgeShell>
        </>
      ) : null}
    </QrSurface>
  );
}
